import PropTypes from "prop-types"
import "./styles.scss"
import { Col, Container, Image } from "react-bootstrap"
import React from "react"
const PatentsCard = ({ newsImg, newsDescription, patent }) => {
  return (
    <a
      className="linkTextStyle"
      href={`/booklets/${encodeURIComponent(patent)}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {}
      <Col className="patent-cards-col">
        <Image className="patent-card-img" src={newsImg} />
        <Container className="patent-card">
          <p className="patent-card-text">{newsDescription}</p>
        </Container>
      </Col>
    </a>
  )
}

PatentsCard.propTypes = {
  newsImg: PropTypes.any,

  newsDescription: PropTypes.string,
  patent: PropTypes.string,
}

PatentsCard.defaultProps = {
  newsDate: ``,
  newsDescription: ``,
}

export default PatentsCard
